import axios from '../axios';

class ChoiceSet{
    constructor() {
        this.choice_set_url = '/template/choice_set';
    }
    getChoiceSet(id) {
        return axios(`${this.choice_set_url}/${id}`, { method: 'get'});
    }
    postChoiceSet(params) {
        return axios(`${this.choice_set_url}`, { method: 'post', params});
    }
    putChoiceSet(id, params) {
        return axios(`${this.choice_set_url}/${id}`, { method: 'put', params});
    }
    deleteChoiceSet(id) {
        return axios(`${this.choice_set_url}/${id}`, { method: 'delete'});
    }
    choiceSetList(params){
        return axios(`${this.choice_set_url}/list`, { method: 'get', params});
    }
    choiceSetItemList(item_id,params){
        return axios(`${this.choice_set_url}/list/${item_id}`, { method: 'get',params});
    }
};



export default new ChoiceSet()



// WEBPACK FOOTER //
// ./src/api/modules/choiceSet.js